import { useEffect, useRef } from 'react';
import AnimatedEllipsis from 'src/shared/components/ui/loaders/animated-ellipsis';

type AuthLoadingProps = {
  text: string;
  delay: number;
  from: number;
  to: number;
};

export function AuthLoading({ text, delay, from, to }: AuthLoadingProps) {
  const loadingRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (loadingRef.current) {
      loadingRef.current.style.width = `${from}%`;

      if (from !== to) {
        setTimeout(() => {
          if (loadingRef.current) {
            loadingRef.current.style.transition = `width ${delay * 0.6}ms ease-out`;
            loadingRef.current.style.width = `${to}%`;
          }
        }, 10);
      }
    }
  }, [delay, from, to]);

  return (
    <div className="w-[100vw] h-[100vh] flex flex-col items-center justify-center gap-[25px] bg-white grid-container">
      <img src="/static/images/tekst-logo.svg" alt={'Tekst'} width={0} height={0} className="w-36 h-8" />
      <div className="flex flex-col gap-2 items-center">
        <div className="w-[250px] h-[6px] rounded-sm bg-slate-200 relative overflow-hidden">
          <div
            ref={loadingRef}
            style={{ transition: 'none', width: '0%' }}
            className="bg-primary absolute left-0 h-full shimmer-container"
          >
            <div className="shimmer" />
          </div>
        </div>
        <span className="text-sm">
          {text}
          <AnimatedEllipsis />
        </span>
      </div>
    </div>
  );
}
